/* @flow */

export default class InvestmentProfileDefaults {
  amountMinValue: number;
  minAmountMinValue: number;
  maxAmountMinValue: number;
  maxAmountMaxValue: number;
  maxAmountMultiplier: number;
}
